module.exports = "https://coursera_assets.s3.amazonaws.com/images/ee91090e48f15cb22157ea4e2edc4a82.png";